import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Footer2 } from "../../footer2/index";
import Header from "../../header2/index-two";
import { getYardimAltBaslikListesi, getCollectionsList } from '../../../services/directusService';
import usePageTracking from "../../../hooks/usePageTracking";

const helpData = [
  {
    title: "Abonelik ve Erişim",
    subItems: [

      {
        name: "Abonelik Paketleri",
        content: (
          <>
            <div className="form-horizontal smp-body padded io-text-editor">
              <p>
                İdealonline çeşitli abonelik modellerine sahiptir. İdealonline
                içerisindeki veri tabanlarından içeriği uygun veri tabanlarına ayrı ayrı
                veya hepsine birden abone olunabilir.
              </p>
              <p>
                İdealonline'da şu an bireysel abonelik seçeneği aktif değildir. Veri
                Tabanlarına kurumsal abonelik için kütüphanenize başvurabilirsiniz.
              </p>
              <p>
                Abonelik kapsamındaki yayınlara üyelik işlemi gerçekleştirilse dahi
                erişilemez. İdealonline sadece kurumsal abonelik mantığıyla çalışmaktadır.
              </p>
              <p>
                <a href="mailto:ideal@idealkultur.com">idealonline@idealkultur.com</a>
              </p>
            </div>
          </>
        ),
      },
      {
        name: "Açık Erişim",
        content: (
          <>

            <div className="form-horizontal smp-body padded io-text-editor">
              <p>
                “Açık bilim” araştırma çıktılarına (bilimsel yayınlar ve veriler) ve
                süreçlerine herkesin serbestçe erişimini ve bu çıktıların ortak çalışma
                yapmak için kullanım, dağıtım ve üretimini kolaylaştıran bir bilim
                uygulamasıdır.
              </p>
              <p>
                “Açık erişim” ise kamu kaynaklarıyla üretilen bilimsel yayınların tam
                metinlerine ve verilerine ücretsiz erişim sağlamak ve bu yayın ve verileri
                değişik amaçlarla kullanmak olarak tanımlanmaktadır.
              </p>
              <p>
                Günümüzde çoğu yazar yapmış oldukları yayınlara araştırmacıların serbestçe
                erişmesini arzu etmektedir. Bu çerçevede açık erişim yayın yapan hakemli
                dergiler İdealonline’da indekslenmekte ve tam metin olarak
                araştırmacıların hizmetine sunulmaktadır.
              </p>
              <p>
                İdealonline’daki Açık Erişim dergilere serbestçe erişilmektedir.
                İdealonline daha önceden belirlenmiş kriterlere uygun Açık Erişim
                dergileri kabul etmektedir. Bu özelliği nedeniyle İdealonline tam metin
                indeks özelliği taşımaktadır.
              </p>
            </div>


          </>
        ),
      },
    ],
  },
  {
    title: "Arama",
    subItems: [

      {
        name: "Basit Arama",
        content: (
          <>

            <div className="form-horizontal smp-body padded io-text-editor">
              <p>
                İdealonline’da arama yapmak için sayfa üstlerinde yer alan Basit Arama
                özelliğini kullanabilirsiniz. Basit Arama kutusu İdealonline veri
                tabanında bir veya birden çok terim ile arama yapmanıza izin verir.
                İdealonline, Basit Arama kutusuna yazılan arama terimlerini VE operatörü
                ile bağlayarak arar. Arama Sonuç Listesi ile sunulan Filtreleme
                Seçenekleri ile arama sonucunu isabetli hale getirmeye aracılık eder.
              </p>
              <ul>
                <li>
                  Arama yapmak için basit arama kutusuna bir veya birden çok terim
                  girebilirsiniz. İdealonline, daha önceden yapılmış arama terimlerini
                  kaydeder ve ilk dört karakterden sonra bunları açılan menüde
                  listeleyerek araştırmacının terimi seçerek arama yapmasına yardımcı olan
                  bir özelliğe sahiptir.
                </li>
                <li>
                  Basit arama kutusuna girilen terimlerin üst verilerde ve tam metinde
                  aranması için “Ara” ikonuna basılması yeterlidir. Üst veri, doküman
                  başlıkları, yazarlar, dokümanın yer aldığı kaynak başlığı, özet ve
                  anahtar kelime gibi veri türlerini içeren alanlardan oluşur. Tam metin
                  ise bir dokümanın içerdiği tüm terimlerden oluşur.
                </li>
                <li>
                  İdealonline aranan terimlerin geçtiği dokümanları Arama Sonuç Sayfasında
                  ilgililik oranına göre listeler. Araştırmacı dilerse listelenen
                  dokümanları tarih, başlık veya yazara göre de sıralayabilir.
                </li>
                <li>
                  Arama sonuçları varsayılan olarak 20 adetlik liste ile sunulur.
                  Araştırmacı dilerse arama sonucunu 5, 10, 20, 50 ve 100 adetlik
                  listelerle görüntüleyebilir. Varsayılan olarak belirtilen 20 adedi veya
                  seçilen sonuç sayısı görüntüleme opsiyonundan fazla olan yayınları
                  görüntülemek için sayfa üstünde ve altında bulunan sonuç sayfası
                  rakamlarına ile İleri veya Geri ikonları kullanılır.
                </li>
                <li>
                  Özetlerin görüntülenmesi için Özet başlığına tıklanması yeterlidir.
                </li>
                <li>
                  Uzun özetlerin görüntülenmesi için Daha Fazla başlığına tıklanması
                  yeterlidir.
                </li>
                <li>
                  Abonelik kapsamındaki yayınların tam metnine erişmek için PDF
                  bağlantısına tıklanır.
                </li>
              </ul>
              <p>&nbsp;</p>
              <p>
                Abonelik kapsamında tam metin erişim olan dokümanlar açık kilit ikonu ile
                belirtilir.
              </p>
              <p>&nbsp;</p>
              <p>Abonelik kapsamında olmayan yayınlar satın alınabilir.</p>
            </div>


          </>
        ),
      },
      {
        name: "Yayın Arama",
        content: (
          <>
            <div className="form-horizontal smp-body padded io-text-editor">
              <p>
                Yayın Arama belli yayınların aranmasına aracılık eden bir özelliktir. Belli
                bir yayının ve o yayının içeriğine erişmenin kolay yoludur. Yayın arama
                aşağıdaki seçeneklerle yapılır ve ilgili yayına doğrudan ulaşımı
                kolaylaştırır:
              </p>
              <ul>
                <li>Yayın Başlığı</li>
                <li>Cilt</li>
                <li>Sayı</li>
              </ul>
            </div>

          </>
        ),
      },
    ],
  },
  {
    title: "Eğitim ve Rehberler",
    subItems: [
      {
        name: "Kullanıcı Kılavuzu",
        content: (
          <>
            <h3>Kullanıcı Kılavuzu</h3>
            <p>Platformu nasıl kullanacağınızı anlatan detaylı rehber.</p>
          </>
        ),
      },
      {
        name: "Eğitim",
        content: (
          <>
            <h3>Eğitim</h3>
            <p>Kullanıcılar için online eğitim videoları ve rehberler bulunmaktadır.</p>
          </>
        ),
      },
      {
        name: "SSS",
        content: (
          <>
            <h3>Sıkça Sorulan Sorular</h3>
            <p>Kullanıcıların en çok sorduğu sorular ve yanıtları burada listelenmektedir.</p>
          </>
        ),
      },
    ],
  },
];

const Help = () => {
  usePageTracking("help");
  const [helpData, setHelpData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedContent, setSelectedContent] = useState(null);
  const { pathname } = useLocation();

    useEffect(() => {
      // Anında yukarı sıfırla (hiç animasyon yok)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"   // <--- ÖNEMLİ KISIM
      });
    }, [pathname]);

  const toggleMenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleContentChange = (content) => {
    setSelectedContent(content);
  };

    const fetchHelpData = async () => {
    try {
      const response = await getYardimAltBaslikListesi();
      const rawData = response?.data || [];

      // kategoriId.title'e göre grupluyoruz
      const grouped = {};
      rawData.forEach(item => {
        const anaBaslik = item.kategoriId?.title || "Diğer";

        if (!grouped[anaBaslik]) grouped[anaBaslik] = [];

        grouped[anaBaslik].push({
          name: item.title?.replace(/^D\.\s*/, ""), // "D. " önekini kaldır (isteğe bağlı)
          content: (
            <div
              className="form-horizontal smp-body padded io-text-editor"
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          ),
        });
      });

      // format: [{ title: "...", subItems: [...] }]
      const formatted = Object.entries(grouped).map(([title, subItems]) => ({
        title: title.replace(/^D\.\s*/, ""), // kategorideki "D. " önekini de kaldırmak istersen
        subItems,
      }));

      setHelpData(formatted);

      // İlk kategoriyi aç, ilk içeriği seç
      if (formatted.length && formatted[0].subItems.length) {
        setOpenIndex(0);
        setSelectedContent(formatted[0].subItems[0]);
      }

    } catch (err) {
      console.error("Yardım verileri alınamadı:", err);
    }
  };

 useEffect(() => {
  fetchHelpData();
}, []);


  return (
    <div className="main-wrapper">
      <Header />

      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12"></div>
          </div>
        </div>
      </div>

      <section className="page-content course-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <div className="card shadow-lg border-0 rounded-lg sidebar-menu">
                <div className="card-header  text-center rounded-top">
                  <h5 className="text-newdarkfume mb-0"> Yardım Kategorileri</h5>
                </div>
                <div className="card-body p-3">
                  <ul className="list-group list-group-flush">
                    {helpData.map((category, index) => (
                      <li key={index} className="list-group-item border-0 p-2">
                        <button
                          className="d-flex justify-content-between align-items-center w-100 text-start bg-transparent border-0 text-newdarkfume fw-bold fs-6"
                          onClick={() => toggleMenu(index)}
                        >
                          {category.title}
                        </button>
                        {openIndex === index && (
                          <ul className="mt-2 ps-3 border-start border-2 border-primary-green">
                            {category.subItems.map((item, idx) => (
                              <li key={idx} className="py-1">
                                <a
                                  href="#"
                                  className="text-decoration-none text-darkfume d-block py-1 px-2 rounded"
                                  style={{
                                    transition: "all 0.3s ease-in-out",
                                    fontSize: "14px",
                                  }}
                                  onMouseOver={(e) => (e.target.style.background = "#f0f0f0")}
                                  onMouseOut={(e) => (e.target.style.background = "transparent")}
                                  onClick={() => handleContentChange(item)}
                                >
                                  {item.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-12 about-grid">
              <div className="card">
                <div className="card-header">
                  <h5 className="text-primary" style={{ marginBottom: "0px" }}> {selectedContent?.name || "--"}</h5>
                </div>
                <div className="card-body">
                  {selectedContent?.content || "--"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </div>
  );
};

export default Help;